import React from 'react';
import { createBrowserRouter, replace } from 'react-router-dom';
import routesMap from 'src/js/router/helpers/routes-map';
import CorePage from 'src/js/components/core-page';
import FallbackRedirect from 'src/js/components/fallback-redirect';
import CategoryStepContainer from '../../containers/site-setup/category-step-container';
import GalleryLayoutContainer from '../../containers/gallery-layout-container';
import SiteNameStepContainer from '../../containers/site-setup/site-name-step-container';
import BusinessNameStepContainer from '../../containers/site-setup/business-name-step-container';
import BusinessDetailsStepContainer from '../../containers/site-setup/business-details-step-container';
import HowToBuildStepContainer from '../../containers/site-setup/how-to-build-step-container';
import TemplateDetailsContainer from '../../containers/template-details-container';
import UseTemplateContainer from '../../containers/use-template-container';
import PlatformSelectorContainer from '../../containers/platform-selector-container';

const createRouter = () =>
  createBrowserRouter([
    {
      path: '*?',
      element: <FallbackRedirect />,
    },
    {
      path: routesMap.index.pattern(),
      element: <CorePage />,
      children: [
        {
          path: routesMap.userArchetypes.pattern(),
          loader: () => replace(routesMap.siteCategory.url()),
        },
        {
          path: routesMap.siteCategory.pattern(),
          element: <CategoryStepContainer />,
        },
        {
          path: routesMap.gallery.pattern(),
          element: <GalleryLayoutContainer />,
          children: [
            {
              path: `create`,
              element: <UseTemplateContainer />,
            },
          ],
        },
        {
          path: routesMap.siteName.pattern(),
          element: <SiteNameStepContainer />,
          children: [
            {
              path: `create`,
              element: <UseTemplateContainer />,
            },
          ],
        },
        {
          path: routesMap.businessName.pattern(),
          element: <BusinessNameStepContainer />,
          children: [
            {
              path: `create`,
              element: <UseTemplateContainer />,
            },
          ],
        },
        {
          path: routesMap.businessDetails.pattern(),
          element: <BusinessDetailsStepContainer />,
          children: [
            {
              path: `create`,
              element: <UseTemplateContainer />,
            },
          ],
        },
        {
          path: routesMap.templateDetails.pattern(),
          element: <TemplateDetailsContainer />,
          children: [
            {
              path: `create`,
              element: <UseTemplateContainer />,
            },
          ],
        },
        {
          path: routesMap.platformSelector.pattern(),
          element: <PlatformSelectorContainer />,
        },
        {
          path: routesMap.useTemplate.pattern(),
          element: <UseTemplateContainer />,
        },
        {
          path: routesMap.howToBuild.pattern(),
          element: <HowToBuildStepContainer />,
        },
      ],
    },
  ]);
export default createRouter;
